














import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  props: {
    perks: {
      type: Array as PropType<string[]>,
      required: true
    },
    checkColorClass: {
      type: String,
      required: false,
      default: 'tw-text-primary'
    }
  },
  setup() {
    return { faCheck }
  }
})
